import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SystemSelectService } from '../system-select/system-select.service';
import { RouteValidationService } from "../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-master-tool-list',
  templateUrl: './master-tool-list.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./master-tool-list.component.scss']
})
export class MasterToolListComponent implements OnInit, OnDestroy {

  constructor(private systemSelectService: SystemSelectService, public routerValidationService: RouteValidationService) { }

  system;
  selected: string = 'default';


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => this.system = system);
    this.systemSelectService.get();

    this.routerValidationService.selected$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(s => this.selected = s);
    this.routerValidationService.get();
  }

}
